import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {FlywheelComponent} from '@gl/lit/lib/component.js';
import styles from './style.scss';
import {getCSRFToken} from '@gl/lit/utils/auth.js';
import {createRef, ref} from 'lit/directives/ref.js';
import {property} from 'lit-element';

export const LOGIN_BUTTONS_ELEMENT_TAG = 'login-buttons';

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
declare let webAuth: Record<string, any>;

/**
 * LoginButtons -- Description here
 */
@customElement(LOGIN_BUTTONS_ELEMENT_TAG)
export default class LoginButtons extends FlywheelComponent {
  @property({type: Boolean, attribute: 'show-signup'})
  showSignup = false;

  @property({attribute: 'login-path'})
  loginPath = '';

  @property({attribute: 'signup-path'})
  signupPath = '';

  private firstForm = createRef();
  private secondForm = createRef();

  static get styles() {
    return [styles];
  }

  render() {
    return html`
      <div class="login-buttons">
        ${this.renderLogin()}
        ${this.showSignup ? this.renderSignup() : html`<br /><br />`}
      </div>
    `;
  }

  renderLogin() {
    return html`
      <form ${ref(this.firstForm)} method="post" action="${this.loginPath}">
        <fly-button
          data-cy-button="login"
          type="submit"
          @click="${() => {
            (this.firstForm.value as HTMLFormElement).submit();
          }}"
        >
          Login
        </fly-button>
        <input
          type="hidden"
          name="authenticity_token"
          value="${getCSRFToken()}"
        />
      </form>
    `;
  }

  renderSignup() {
    return html`
      <form ${ref(this.secondForm)} method="post" action="${this.signupPath}">
        <fly-button
          class="sign-up-button"
          data-cy-button="login"
          type="submit"
          intent="base"
          @click="${() => {
            (this.secondForm.value as HTMLFormElement).submit();
          }}"
          variant="link"
        >
          Or Signup
        </fly-button>
        <input
          type="hidden"
          name="authenticity_token"
          value="${getCSRFToken()}"
        />
      </form>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [LOGIN_BUTTONS_ELEMENT_TAG]: LoginButtons;
  }
}
